import { MetaFunction } from '@remix-run/node'

import { Breadcrumb, Container } from '~/components'
import { TopFooter, TopHeader, TermsPage } from '~/features'

export const meta: MetaFunction = ({ matches }) => {
  const parentMeta = matches
    .flatMap((match) => match.meta ?? [])
    .filter((meta) => !('title' in meta))
  return [
    ...parentMeta,
    {
      title: '利用規約 | シェアオフィス コワーキングスペース検索サイト',
    },
  ]
}

export default function TermsOfService() {
  return (
    <>
      <TopHeader />
      <Container className="pt-14">
        <Breadcrumb
          links={[{ href: '/', text: 'トップ' }, { text: '利用規約' }]}
        />
      </Container>
      <TermsPage />
      <TopFooter />
    </>
  )
}
